<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormCalendar fieldName="operation_date_from"
                                      label="Operation date from"
                                      size="2"
                                      v-model:field="search.operation_date_from" />
                        <FormCalendar fieldName="operation_date_to"
                                      label="Operation date to"
                                      size="2"
                                      v-model:field="search.operation_date_to" />

                        <FormInputNumber fieldName="statement_amount_from"
                                         label="Statement amount from"
                                         size="2"
                                         v-model:field="search.statement_amount_from" />
                        <FormInputNumber fieldName="statement_amount_to"
                                         label="Statement amount to"
                                         size="2"
                                         v-model:field="search.statement_amount_to" />

                        <FormInputNumber fieldName="assigned_amount_from"
                                         label="Assigned amount from"
                                         size="2"
                                         v-model:field="search.assigned_amount_from" />
                        <FormInputNumber fieldName="assigned_amount_to"
                                         label="Assigned amount to"
                                         size="2"
                                         v-model:field="search.assigned_amount_to" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="transfer_title"
                                       label="Transfer title"
                                       size="3"
                                       v-model:field="search.transfer_title" />

                        <FormInputText fieldName="company_bank_account"
                                       label="Company bank account"
                                       size="3"
                                       v-model:field="search.company_bank_account" />

                        <FormInputText fieldName="contractor_bank_account"
                                       label="Contractor bank account"
                                       size="3"
                                       v-model:field="search.contractor_bank_account" />

                        <FormInputText fieldName="contractor_name"
                                       label="Contractor name"
                                       size="3"
                                       v-model:field="search.contractor_name" />
                    </div>
                    <div class="grid">
                        <FormMultiselect fieldName="contractor_id"
                                         label="Contractor"
                                         size="6"
                                         :options="select?.contractors"
                                         v-model:field="search.contractor_id" />
                        <FormMultiselect fieldName="project_id"
                                         label="Project"
                                         size="6"
                                         :options="select?.projects"
                                         v-model:field="search.project_id" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import { prepareSearch, yesNoOptions } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})
const options = ["projects", "contractors"];
const select = ref(null);

prepareSearch(search, props, options, select)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
